<template>
  <div class="add">
    <div class="content">
      <Header :title="title"></Header>
      <div class="line" v-if="!courseInfo.course_id"></div>
      <div class="collapse"
           v-if="!courseInfo.course_id">
        <van-dropdown-menu class="dropdown">
          <van-dropdown-item title="选择分类："
                             @change="changeClass"
                             title-class="class_title"
                             v-model="addData.classify_id"
                             :options="columns" />
          <span class="noClass">{{classifyName}}</span>
        </van-dropdown-menu>
      </div>
      <van-field v-model="addData.title"
                 class="ques_input"
                 rows="3"
                 autosize
                 type="textarea"
                 maxlength="100"
                 placeholder="请输问题标题"
                 show-word-limit />
      <van-field v-model="addData.content"
                 class="ques_input ques_content"
                 rows="8"
                 autosize
                 type="textarea"
                 maxlength="300"
                 placeholder="提出你的问题，会有老师来专门解答哦！(300字)"
                 show-word-limit />
      <div class="ques_imgs">
        <van-uploader v-model="fileList"
                      :before-delete="del_img"
                      :after-read="afterRead"
                      :max-count="9"
                      multiple />
      </div>
    </div>
    <van-popup v-model="showPicker"
               position="bottom">
      <van-picker show-toolbar
                  :columns="columns"
                  @cancel="showPicker = false"
                  @confirm="onConfirm" />
    </van-popup>
    <div class="bottomFixed">
      <div v-if="courseInfo.course_id"
           class="courseTitle">
        <div class="lines"></div>
        <p class="askForm">来自：<span>{{courseInfo.course_chapter_title}}</span> <span> > {{courseInfo.course_periods_title}}</span></p>
      </div>
      <div class="warn">请勿发布与专业知识无关的问题，否则将禁用账号</div>
      <div v-if="courseInfo.course_id"
           class="submit_question"
           @click="submitQues()">提交问题</div>
      <div v-else
           class="submit_question"
           @click="submitQues()">发布问题</div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "add",
  components: {
    Header
  },
  data () {
    return {
      title: {
        name: "提问"
      },
      showPicker: false,
      classifyName: '',
      columns: [],
      classify: [],
      message: '',
      content: '',
      showWordLimit: true,
      fileList: [],
      images: [],
      addData: {
        classify_id: '',
        title: '',
        content: ''
      },
      courseInfo: {}
    };
  },
  created () {
    this.courseInfo = this.$route.query;

    this.getClassify();
  },
  methods: {
    onConfirm (value, index) {
      this.classifyName = value;
      this.addData.classify_id = this.classify[index].id;
      this.showPicker = false;
    },
    onCancel () {
      this.$toast('取消');
    },
    selectClassfiy () {
      this.showPicker = true;
    },
    changeClass (value) {
      this.columns.forEach(item => {
        this.addData.classify_id = value;
        if (value === item.value) {
          this.classifyName = item.text;
        }
      })
    },
    getClassify () {
      let param = { classify_id: this.$store.state.personInfo.classify_id || localStorage.classify_id }
      this.$http.get(`/api/app/ask/classify`, param).then((res) => {
        this.classify = res;
        if (res.length === 0) {
          this.classifyName = '暂无二级分类'
        }
        res.forEach(item => {
          this.columns.push({ text: item.title, value: item.id })
          // this.columns.push(item.title)
        });;
      })
    },
    /**
     * classify_id  所选类型，没有选择二级分类，则传0
     * title 提问标题
     * content 提问内容
     * images 图片
     */
    submitQues () {
      let url = 'jask';
      if (this.courseInfo.course_id) {//from章节视频页面
        delete this.addData.classify_id;
        this.addData.course_id = this.courseInfo.course_id;
        this.addData.course_chapter_id = this.courseInfo.course_chapter_id;
        this.addData.course_periods_id = this.courseInfo.course_periods_id;
        url = 'cask';
      } else {//from 问答列表
        if (this.classify.length > 0) {
          if (this.addData.classify_id == '') {
            this.addData.classify_id = this.$store.state.personInfo.classify_id || localStorage.classify_id;
          }
        } else {
          // 没有二级分类传一级分类
          this.addData.classify_id = this.$store.state.personInfo.classify_id || localStorage.classify_id;
        }
      }
      if (!this.addData.title) {
        this.$toast('请填写问题标题');
        return;
      }
      if (!this.addData.content) {
        this.$toast('请填写问题详情');
        return;
      }
      let imgs = [];
      this.images.forEach(item => {
        imgs.push(item.url);
      })
      this.addData.images = imgs.join(',');
      this.$http.post(`/api/app/ask/` + url, this.addData).then((res) => {
        this.$router.go(-1);
      })
    },
    /**
     * 上传图片
     */
    async afterRead (file) {
      const formdata = new FormData();
      let list = [];
      // 多张图片file为Array类型
      if (Array.isArray(file)) {
        file.forEach(item => {
          formdata.append("file[]", item.file);
        });
        await this.$http.post(`/api/app/public/images`, formdata).then((res) => {
          res.forEach(item => {
            list.push({ url: item.path })
          })
        });
      } else {
        // 如果为单张图片 file为Object类型
        formdata.append("file", file.file);
        await this.$http.post(`/api/app/public/img`, formdata).then((res) => {
          list.push({ url: res.path });
        });
      }
      list.forEach(item => {
        this.images.push({ url: item.url })
      })
    },
    //删除图片
    async del_img (file, detail) {
      this.images.splice(detail.index, 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.add {
  .content {
    @extend %default-bg;
    font-family: PingFang SC;
    background-color: #ffffff;
    padding-bottom: 250px;
    overflow: hidden;
  }
  .line{
    height: 10px;
    background-color: #F6F6F6;
  }
  .collapse {
    // border-bottom: 1px solid #f6f6f6;
    padding: 20px;
    padding-top: 0;
    /deep/ .dropdown {
      z-index: 9;
      border-bottom: 1px solid #f6f6f6;
      color: #333333;
      position: relative;
      text-align: left;
      .van-dropdown-menu__bar {
        box-shadow: none;
      }
      .van-cell__value {
        display: none;
      }
      .noClass {
        top: 0;
        position: absolute;
        max-width: 300px;
        @include eps;
        left: 50%;
        transform: translateX(-50%);
        font-size: 30px;
        height: 80px;
        line-height: 80px;
      }
      .van-cell__title {
        text-align: center;
      }
      .class_title {
        position: absolute;
        left: 0;
        color: #999999;
        width: 100%;
        &::after {
          border-width: 10px;
          top: 36px;
          right: 10px;
        }
      }
    }
    .select_class {
      font-size: 30px;
      color: #999999;
      .selected {
        color: #333333;
      }
      img {
        width: 24px;
        vertical-align: middle;
        float: right;
        margin-top: 8px;
      }
    }
  }
  .ques_input {
    // position: relative;
    height: 300px;
    padding-top: 42px;
    padding-bottom: 42px;
    // border-bottom: 1px solid #f6f6f6;
    /deep/ {
      .van-field__control {
        overflow: hidden;
        height: 220px !important;
        line-height: 46px;
        overflow-y: auto;
      }
      .van-field__word-limit {
        // height: 60px;
        // line-height: 60px;
        font-size: 24px;
        // position: absolute;
        // top: 90px;
        // right: 0;
      }
    }
  }
  .ques_content {
    height: 300px;
  }
  .tips {
    font-size: 30px;
    color: #999999;
    padding: 42px 30px;
  }
  .ques_imgs {
    padding: 42px 30px 0 30px;
    /deep/ {
      .van-uploader {
        display: block;
        .van-uploader__wrapper {
          display: block !important;
        }
      }
      .van-uploader__upload {
        display: block !important;
        width: 200px;
        height: 200px;
        text-align: center;
        line-height: 200px;
        margin-bottom: 100px;
      }
      .van-uploader__preview {
        border-radius: 5px;
        width: 30%;
        height: 200px;
        display: inline-block;
        .van-image {
          width: 100%;
        }
      }
      img {
        width: 100%;
        object-fit: unset !important;
        display: inline-block;
      }
    }
  }
  .add_img {
    width: 200px;
    height: 200px;
    margin-left: 30px;
    img {
      width: 100%;
    }
  }
}
.bottomFixed {
  position: fixed;
  background-color: #ffffff;
  bottom: 0;
  width: 100%;
  z-index: 22;
  overflow: hidden;
  .warn {
    font-size: 24px;
    color: #999999;
    font-weight: 400;
    padding: 44px 20px;
  }
  .submit_question {
    font-size: 34px;
    color: #ffffff;
    background-color: $theme_color;
    height: 88px;
    line-height: 88px;
    text-align: center;
    margin: 0 auto;
    width: 100%;
  }
  .lines {
    height: 30px;
    background-color: #f6f6f6;
  }
  .askForm {
    padding: 0 20px;
    font-size: 24px;
    color: #999999;
    margin-top: 34px;
    span {
      color: $theme_color;
    }
  }
}
</style>
